module.exports = __webpack_public_path__ + "img/zoom.5c7ff42a.svg";